import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="collapsible-table-row"
export default class extends Controller {
  static targets = ["expandIcon"];
  static values = {
    rowId: String,
    expanded: { type: Boolean, default: false },
  };

  connect() {
    this.setState(this.expandedValue);
  }

  toggle(event) {
    // Prevent toggle if clicking on a button or link inside the row
    if (event.target.tagName === "BUTTON" || event.target.closest("button")) {
      return;
    }

    this.setState(!this.expandedValue);
  }

  setState(open) {
    this.expandedValue = open;

    // Find all subcategory rows for this category
    const subcategoryRows = document.querySelectorAll(
      `tr[data-subcategory="${this.rowIdValue}"]`
    );

    subcategoryRows.forEach((row) => {
      if (open) {
        // Show row - use setProperty with important flag
        row.style.setProperty("display", "table-row", "important");
        // Force a reflow to ensure display is applied
        void row.offsetHeight;
        // Now set opacity in next frame
        requestAnimationFrame(() => {
          row.style.setProperty("opacity", "1", "important");
        });
      } else {
        // Hide row - fade out first, then hide
        row.style.setProperty("opacity", "0", "important");
        setTimeout(() => {
          if (!this.expandedValue) {
            row.style.setProperty("display", "none", "important");
          }
        }, 300);
      }
    });

    // Update parent collapsible section's max-height
    this.updateParentSectionHeight();

    // Rotate the chevron icon
    if (this.hasExpandIconTarget) {
      if (open) {
        this.expandIconTarget.classList.add("rotate-180");
      } else {
        this.expandIconTarget.classList.remove("rotate-180");
      }
    }
  }

  updateParentSectionHeight() {
    // Find the parent collapsible section
    const collapsibleSection = this.element.closest(
      '[data-controller*="collapsible-section"]'
    );
    if (collapsibleSection) {
      const bodyElement = collapsibleSection.querySelector(
        "[data-collapsible-section-target='body']"
      );
      if (bodyElement) {
        // Update max-height to accommodate new content
        requestAnimationFrame(() => {
          bodyElement.style.maxHeight = bodyElement.scrollHeight + "px";
        });
      }
    }
  }
}
